import * as voxlinkMethods from '../../consts/voxlink/voxlinkMethods';
import getVoxlinkClient from './voxlinkClient';
import voxlinkMappingService from './voxlinkMappingService';

// isThrowError: callers need the gateway status and `code`; isLogResponse: false - responses identify the user
const postAuthSession = () =>
    getVoxlinkClient().callPost({
        path: voxlinkMethods.AUTH_SESSIONS,
        body: {},
        mapping: voxlinkMappingService.authSessionMapping,
        isThrowError: true,
        isLogResponse: false,
    });

const deleteAuthSession = (sessionId) =>
    getVoxlinkClient().callDel({
        path: voxlinkMethods.AUTH_SESSION,
        pathParams: [sessionId],
        isCookieAuth: true,
        isThrowError: true,
    });

export default {
    postAuthSession,
    deleteAuthSession,
};
